import {gsap} from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from "gsap/ScrollTrigger";
 
gsap.registerPlugin(SplitText, ScrollTrigger)

import { enlargeThumb, closeThumbOverlay } from './thumbAnimation';



// ******************
// Selectors
// ******************
const crosses = document.querySelectorAll('.ris--featCol__cross')
const pageTitle = document.querySelector('.ris--mainCol__title')
const mainDescription = document.querySelector('.ris--mainCol__description')
const ctaButton = document.querySelector('.ctaButton')
const features = document.querySelectorAll('.ris--featCol__item')
const functionBar = document.querySelector('.ris--featCol__bar')
const functionTitle = document.querySelector('.ris--featCol__title')
let heroImg
if(window.innerWidth <= 768) {heroImg = document.getElementById('risHero_phone')} 
if (window.innerWidth > 769) {heroImg = document.getElementById('risHero_tablet')}
if(window.innerWidth > 964) {heroImg = document.getElementById('risHero_phone')}
// Functions
const thumbs = document.querySelectorAll('.ris--featCol__item-photo img')
// Benefits
const benefitsSection = document.querySelector('.risBenefits--title')
const benefitsTitle = document.querySelector('.risBenefits--title')
const benefitsBar = document.querySelector('.risBenefits--bar')
const benefitsItems = document.querySelectorAll('.risBenefits--item')


// ***************
// Title animation
// ***************
window.addEventListener('load', () => {
  if(window.innerWidth <= 768) {
    const titleAnimation = gsap.timeline()
    .from({}, {duration: 1})
    .from(pageTitle, {y: '50%', opacity: 0})
    .from(mainDescription, {y: 30, opacity: 0}, '-=.4')
    .from(ctaButton, {x: -50, opacity: 0, ease: 'back'}, '-=.3')
    .from(heroImg, {y: 50, opacity: 0}, '<')
  } else {
    // console.log('big')
    const titleAnimation = gsap.timeline()
    .from({}, {duration: 1})
    .from(pageTitle, {y: '50%', opacity: 0})
    .from(mainDescription, {y: 30, opacity: 0}, '-=.4')
    .from(ctaButton, {x: -50, opacity: 0, ease: 'back'}, '-=.3')
    .from(heroImg, {y: 50, opacity: 0}, '<')
    .from(functionTitle, {y: 30, opacity: 0}, '<')
    .from(functionBar, {scaleX: 0}, '-=.3')
    .from([features], {x: 100, opacity: 0, stagger: 0.2}, '<')
  }
})

// ******************
// Unfold animation
// ******************
crosses.forEach((cross) => {
  cross.addEventListener('click', () => {
    // Selectors
    const viewportWidth = window.innerWidth
    const line1 = cross.querySelector('.ris--featCol__cross-line_1')
    const content = cross.parentElement.parentElement.querySelector('.ris--featCol__item-content')
    const header = cross.parentElement.parentElement.querySelector('.ris--featCol__item-header')

    // Less than tablet
    if(viewportWidth <= 768) {
      // console.log('phone size')
      cross.classList.toggle('active')
      
      if(cross.classList.contains('active')) {
        const openAnim = gsap.timeline()
        .to(line1, {rotate: '0deg'})
        .to(content, {height: 'auto', padding: '1em'}, '<')
      } else {
        const closeAnim = gsap.timeline()
        .to(line1, {rotate: '-90deg'})
        .to(content, {height: 0, padding: 0}, '<')
      }
    }

    // Tablet
    if (viewportWidth > 768) {
      // console.log('tablet size')
      // Selectors
      const items = document.querySelectorAll('.ris--featCol__item')
      const previousActiveCross = document.querySelector('.ris--featCol__cross.active')

      // Current item index
      const currentItem = cross.parentElement.parentElement
      const currentIndex = Array.prototype.indexOf.call(items, currentItem)

      // If active cross find parent item index
      let previousIndex = null
      let previousActiveItem = null
      if(previousActiveCross) {
        previousActiveItem = previousActiveCross.parentElement.parentElement
        previousIndex = Array.prototype.indexOf.call(items, previousActiveItem)
      }

      cross.classList.toggle('active')

      // First choice
      if(previousIndex == null) {
        // console.log('first choice')
        if(cross.classList.contains('active')) {
          const openAnim = gsap.timeline()
          .to(line1, {rotate: '0deg'})
          // .to(content, {height: 'auto', padding: '1em'}, '<')
          .to(content, {height: '100%', padding: '1em'}, '<')
          .to(header, {backgroundColor: '#edf8fd'}, '<')
        } else {
          const closeAnim = gsap.timeline()
          .to(line1, {rotate: '-90deg'})
          .to(content, {height: 0, padding: 0}, '<')
          .to(header, {backgroundColor: 'white'}, '<')
        }
      }

      // Not same item choice
      if( previousIndex != null && previousIndex != currentIndex) {
        // console.log('not same index')
        const previousLine1 = previousActiveCross.querySelector('.ris--featCol__cross-line_1')
        const previousContent = previousActiveItem.querySelector('.ris--featCol__item-content')
        const previousHeader = previousActiveItem.querySelector('.ris--featCol__item-header')
        previousActiveCross.classList.remove('active')

        if(cross.classList.contains('active')) {
          const openAnim = gsap.timeline()
          .to(previousLine1, {rotate: '-90deg'})
          .to(previousContent, {height: 0, padding: 0}, '<')
          .to(previousHeader, {backgroundColor: 'white'}, '<')
          .to(line1, {rotate: '0deg'}, '<')
          // .to(content, {height: 'auto', padding: '1em'}, '<')
          .to(content, {height: '100%', padding: '1em'}, '<')
          .to(header, {backgroundColor: '#edf8fd'}, '<')

        } 
      }
      
      // Same item choice
      if (previousIndex == currentIndex) {
        // console.log('same index')
        if(cross.classList.contains('active')) {
          const openAnim = gsap.timeline()
          .to(line1, {rotate: '0deg'})
          .to(content, {height: '100%', padding: '1em'}, '<')
          .to(header, {backgroundColor: '#edf8fd'}, '<')

        } else {
          const closeAnim = gsap.timeline()
          .to(line1, {rotate: '-90deg'})
          .to(content, {height: 0, padding: 0}, '<')
          .to(header, {backgroundColor: 'white'}, '<')
        }
      }
    }
  })
})

// ******************
// Enlarge thumbnails
// ******************
thumbs.forEach((thumb) => {
  if(window.innerWidth >= 768) {
    thumb.addEventListener('click', () => {
      const imgSrc = thumb.src
      enlargeThumb(imgSrc)
    })
  } else return
})


// ******************
// Benefits Animation
// ******************
const benefitAnimation = gsap.timeline({
  scrollTrigger: {
    trigger: benefitsSection,
    start: 'top 70%'
  }
})
.from(benefitsTitle, {y: 30, opacity: 0})
.from(benefitsBar, {scaleX: 0, duration: 1}, '<')
.from([benefitsItems], {y: 30, opacity: 0, stagger: 0.2}, '<')